import { parseCookies } from 'nookies';

export default function getCustomDimensions(requestId: string) {
    return {
        dimension1: getUserId(),
        dimension2: getHitId(getUserId()),
        dimension3: getHitId(getUserId()),
        dimension4: requestId
    }
}

function getUserId() {
    const cookies = parseCookies();
    return clearUserId(cookies['_ga']);
}

function clearUserId(useId: string) {
    let match: RegExpMatchArray;

    if (useId) {
        match = useId.match(/(\d+\.\d+)$/)
    }

    return (match) ? match[1] : null;
}

function getHitId(userId: string) {
    const millis = new Date().getTime();
    return userId + '_' + Math.trunc(+(millis / 1000).toFixed(3));
}